module.exports = __webpack_public_path__ + "img/header_bg.db5236f0.png";